import { fetcher } from "@website/fetcher/fetcher";
import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { GetBalanceMutationKey, GetBalanceResponseTypes } from "./types";

export const getBalanceApiURL = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/wallet/v1/users/balance`;

export const useGetBalance = () => {
  const { isLoggedIn } = useLoginStatus();
  const { data, isLoading, error } = useFetcherV2({
    queryKey: [GetBalanceMutationKey],
    queryFn: () =>
      fetcher({ url: getBalanceApiURL }).then(
        ({ data }) => data as GetBalanceResponseTypes
      ),
    enabled: isLoggedIn
  });

  return {
    isLoadingGetBalance: isLoading,
    balance: data || { balance: 0, creditLimit: 0, ledgerBalance: 0 },
    isBalanceError: error
  };
};
